<template>
  <div class="resend-token-container">
    <b-container class="main-container">
      <b-container>
        <b-row class="mt-sm-4 text-center justify-content-md-center">
          <b-col cols="6">
            <h5 class="access-not-possible-text">ACCESS NOT POSSIBLE</h5>
          </b-col>
        </b-row>
        <b-row class="text-center justify-content-md-center">
          <b-col cols="6">
            <p class="expired-log">First access link expired</p>
          </b-col>
        </b-row>
      </b-container>
      <form
        v-if="!sccess"
        v-on:submit="onSubmit"
        novalidate
        @submit.prevent="validateBeforeSubmit"
      >
        <b-row class="resend-token-body">
          <b-col
            md="10"
            offset-md="1"
          >
            <b-row class="mt-sm-5">
              <b-container>
                <b-alert
                  :show="showErrorAlert"
                  dismissible
                  variant="danger"
                  @dismissed="showErrorAlert=false"
                >
                  <span>
                    <ul>
                      <li
                        v-for="(err, i) in error"
                        :key="i"
                      >
                        {{ err }}
                      </li>
                    </ul>
                  </span>
                </b-alert>
                <br v-if="showErrorAlert">
                <b-row>
                  <b-col>
                    <p class="resend-token-text">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                      eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                      enim ad minim veniam, quis nostrud exercitation ullamco laboris
                      nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                      in reprehenderit in voluptate velit esse cillum dolore eu
                      fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
                      proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                    </p>
                  </b-col>
                </b-row>
              </b-container>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="mt-sm-5 justify-content-md-center">
          <b-col cols="7">
            <p class="support-text">
              <a
                class="privacy-settings-support-text"
                href="mailto:info@carriercommunity.com?subject=Support&cc=Kara@carriercommunity.com;w.schmidt@carriercommunity.com"
              > Need support? Click here!
              </a>
            </p>
            <b-button
              class="resend-token-button"
              block
              :disabled="false"
              type="submit"
              variant="info"
            >RESEND FIRST TIME ACCESS LINK</b-button>
          </b-col>
        </b-row>
      </form>
      <b-container v-else>
        <b-row class="resend-token-body"></b-row>
        <b-row class="mt-sm-5 mb-sm-5 justify-content-md-center">
          <b-col
            md="10"
            offset-md="1"
          >
            <p class="sccess-text">We have sent a new access token to your email!</p>
          </b-col>
        </b-row>
      </b-container>
    </b-container>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ResendToken',
  data() {
    return {
      error: null,
      showErrorAlert: false,
      sccess: false,
    };
  },
  methods: {
    async validateBeforeSubmit() {
      await this.$validator.validate();
    },
    ...mapActions({
      resendToken: 'auth/resendToken',
    }),
    async onSubmit(evt) {
      evt.preventDefault();
      const { token } = this.$route.params;
      if (token.length) {
        const data = {
          token,
        };
        try {
          await this.resendToken(data);
          this.sccess = true;
        } catch (e) {
          console.log(e);
          if (e.response) {
            this.error = e.response.data.non_field_errors;
            this.showErrorAlert = true;
          }
        }
      }
    },
  },
};
</script>

<style>
.resend-token-container {
  min-height: calc(100vh - 120px);
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.resend-token-text {
  font-family: Arial;
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.15;
  letter-spacing: normal;
  text-align: center;
  color: #333333;
}
.main-container {
  background-color: #ffffff;
}
.resend-token-button {
  margin-bottom: 55px;
  font-family: Arial;
  font-size: 15px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.13;
  letter-spacing: normal;
  color: #ffffff;
}

.expired-log {
  font-family: Arial;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.13;
  letter-spacing: normal;
  text-align: center;
  color: #666666;
}
.resend-token-body {
  border-top: #ebebeb 2px solid;
}
.access-not-possible-text {
  font-family: Montserrat;
  font-size: 18px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 0.83;
  letter-spacing: normal;
  text-align: center;
  color: #333333;
}
.support-text {
  font-family: Arial;
  font-size: 15px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.13;
  letter-spacing: normal;
  text-align: center;
  color: #BD9D5F;
}
.sccess-text {
  font-family: Arial;
  font-size: 20px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.13;
  letter-spacing: normal;
  text-align: center;
  color: #666666;
}
</style>
